import { render, staticRenderFns } from "./Forget_password.vue?vue&type=template&id=c6fbd6c0&scoped=true&"
import script from "./Forget_password.vue?vue&type=script&lang=js&"
export * from "./Forget_password.vue?vue&type=script&lang=js&"
import style0 from "./Forget_password.vue?vue&type=style&index=0&id=c6fbd6c0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c6fbd6c0",
  null
  
)

export default component.exports